import React from 'react';
import '../../styles/WhyFBS.css';
import medalIcon from '../../assets/icons/1_year.png';
import certificateIcon from '../../assets/icons/certificates.png';
import packageIcon from '../../assets/icons/package.png';
import caseStudyIcon from '../../assets/icons/case_study.png';
import crt from '../../assets/images/crt.png';
const WhyFBS = () => {
  return (
    <div className="fbs-container  relative bottom-[0rem]">
      <h1 className="fbs-title" style={{ color: 'white' }}>
      <span className= "outerfbs-title">WHY CHOOSE  <br /></span>
        <span className="innerfbs-title">FBS ?</span>
        <img src={crt} alt="Package Icon" className='hidden sm:block'/>
      </h1>
      <div className="fbs-grid md:scale-100 scale-[0.90] relative sm:bottom-[0rem] md:translate-y-0 -translate-y-26 sm:scale-[0.65] sm:-translate-y-16 iphone-12-pro:grid grid-cols-2 gap-0">
        <div className="fbs-item card1">
          <div className="fbs-icon">
            <img src={medalIcon} alt="Medal Icon" />
          </div>
          <div className="fbs-text">
            <p><strong>1 Year</strong></p>
            <p>Job <span id="spn">Experience</span>

            </p>
          </div>
        </div>
        <div className="fbs-item card2">
          <div className="fbs-icon">
            <img src={packageIcon} alt="Package Icon" />
          </div>
          <div className="fbs-text">
            <p><strong>Package:</strong></p>
            <p>3.50 LPA - 22 LPA</p>
          </div>
        </div>

        <div className="fbs-item card3 relative  " id="cs">
          <div className="fbs-icon">
            <img src={caseStudyIcon} alt="Case Study Icon" />
          </div>
          <div className="fbs-text">
            <p><strong>100+</strong></p>
            <p>Case Studies</p>
          </div>
        </div>
        <div className="fbs-item card4 relative  " >
          <div className="fbs-icon ">
            <img src={certificateIcon} alt="Certificate Icon" />
          </div>
          <div className="fbs-text sm:h-[11rem]" >
            <p><strong >15+ Benefits</strong> worth <strong>2.50 Lac</strong> for <strong>FREE</strong></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyFBS;
